export default {
  fields: {
    footerSections: [
      {
        fields: {
          sectionName: { value: "Section 1"},
          sectionType: { fields: { Key: { value: "actionSectionType" }, Phrase: { value: "Action Section" } } },
          footerLinks: [
            {
              fields: {
                Title: { value: "MARKET SELECTOR" },
                Type: { fields: { Key: { value: "MarketSelectorType" }, Phrase: { value: "Market Selector" } } },
                Link: { value: { href: "http://", text: "MARKET SELECTOR" } },
                List: [
                  {
                    fields: {
                      Title: {value: "LANGUAGE LINKS"},
                      Type: { fields: { Key: { value: "groupLinkType" }, Phrase: { value: "Group Link"} } },
                      Link: { value: { href: "http://", text: "LANGUAGE LINKS" } },
                      List: [
                        { fields: { Title: { value: "English"}, Link: { value: { href: "", text: "English" } } } },
                        { fields: { Title: { value: "Spanish"}, Link: { value: { href: "", text: "Spanish" } } } },
                      ],
                    },
                  },
                  {
                    fields: {
                      Title: { value: "United States" },
                      Link: { value: { href: "", text: "United States" } },
                    },
                  },
                ],
              },
            },
            {
              fields: {
                Title: { value: "ARE YOU A DEALER?" },
                Type: { fields: { Key: { value: "dealerLinkType" }, Phrase: { value: "Dealer Link" } } },
                Link: { value: { href: "#" } },
                List: [
                  {
                    fields: {
                      Title: { value: "ARE YOU A DEALER?" },
                      Link: { value: { href: "https://portal.Corporate.com/DPLogin/Login.do", text: "DEALER LOGIN" } }
                    }
                  }
                ],
              }
            }
          ],
        },
      },
      {
        fields: {
          sectionName: { value: "Section 2" },
          sectionType: { fields: { Key: { value: "groupSectionType" }, Phrase: { value: "Group Section" } } },
          footerLinks: [
            {
              fields: {
                Title: {value: "PRODUCTS"},
                Type: { fields: { Key: { value: "groupLinkType" }, Phrase: { value: "Group Link" } } },
                Link: { value: { href: "/Pages/Products.aspx", text: "PRODUCTS" } },
                List: [
                  { fields: { Title: { value: "Tractors"}, Link: { value: { href: "/products/tractors", text: "Tractors" } } } },
                  { fields: { Title: { value: "Harvesting"}, Link: { value: { href: "/products/harvesting", text: "Harvesting" } } } },
                  { fields: { Title: { value: "Advanced Farming Systems&reg; (AFS)"}, Link: { value: { href: "/products/advanced-farming-systems", text: "Advanced Farming Systems™ (AFS)" } } } },
                  { fields: { Title: { value: "Application Equipment"}, Link: { value: { href: "/products/application-equipment", text: "Application Equipment" } } } },
                  { fields: { Title: { value: "Skid Steers &amp; Track Loaders" }, Link: { value: { href: "/products/skid-steers-track-loaders", text: "Skid Steers & Track Loaders" } } } },
                  { fields: { Title: { value: "Loaders &amp; Attachments" }, Link: { value: { href: "/products/loaders-attachments", text: "Loaders & Attachments" } } } },
                  { fields: { Title: { value: "Tillage" }, Link: { value: { href: "/products/tillage", text: "Tillage" } } } },
                  { fields: { Title: { value: "Mowers &amp; Conditioners" }, Link: { value: { href: "/products/mowers-conditioners", text: "Mowers & Conditioners" } } } },
                  { fields: { Title: { value: "Windrowers" }, Link: { value: { href: "/products/windrowers", text: "Windrowers" } } } },
                  { fields: { Title: { value: "Wheel Rakes" }, Link: { value: { href: "/products/wheel-rakes-mergers", text: "Wheel Rakes" } } } },
                  { fields: { Title: { value: "Forage Harvesters &amp; Blowers" }, Link: { value: { href: "/products/forage-harvesters-blowers", text: "Forage Harvesters & Blowers" } } } },
                  { fields: { Title: { value: "Planting &amp; Seeding" }, Link: { value: { href: "/products/planting-seeding", text: "Planting & Seeding" } } } },
                  { fields: { Title: { value: "Balers" }, Link: { value: { href: "/products/balers", text: "Balers" } } } },
                  { fields: { Title: { value: "Our Technology" }, Link: { value: { href: "/company/innovations", text: "Our Technology" } } } },
                  { fields: { Title: { value: "Special Offers" }, Link: { value: { href: "/tools-resources/special-offers", text: "Special Offers" } } } },
                  { fields: { Title: { value: "Auction" }, Link: { value: { href: "", text: "Auction" } } } },
                  { fields: { Title: { value: "Used Equipment" }, Link: { value: { href: "", text: "Used Equipment" } } } },
                ],
              },
            },
          ],
        },
      },
      {
        fields: {
          sectionName: { value: "Section 3" },
          sectionType: { fields: { Key: { value: "groupSectionType" }, Phrase: { value: "Group Section" } } },
          footerLinks: [
            {
              fields: {
                Title: {value: "PARTS &amp; SERVICE"},
                Type: { fields: { Key: { value: "groupLinkType" }, Phrase: { value: "Group Link" } } },
                Link: { value: { href: "/service-support/parts-and-service", text: "PARTS & SERVICE" } },
                List: [],
              },
            },
            {
              fields: {
                Title: { value: "CONNECT WITH " },
                Type: { fields: { Key: { value: "groupLinkType" }, Phrase: { value: "Group Link" } } },
                Link: { value: { href: "/service-support/parts-and-service", text: "CONNECT WITH " } },
                List: [
                  { fields: { Title: { value: "Find a dealer"}, Link: { value: { href: "/dealer-locator", text: "Find a dealer" } } } },
                  { fields: { Title: { value: "Schedule a demo"}, Link: { value: { href: "/connect-with-us/request-a-demo", text: "Schedule a demo" } } } },
                  { fields: { Title: { value: "Contact us"}, Link: { value: { href: "/connect-with-us/contact-us", text: "Contact us" } } } },
                  { fields: { Title: { value: "Email sign up"}, Link: { value: { href: "/connect-with-us/email-signup", text: "Email sign up" } } } },
                  { fields: { Title: { value: "Blog" }, Link: { value: { href: "", text: "Blog" } } } },
                  { fields: { Title: { value: "Events" }, Link: { value: { href: "/connect-with-us/events", text: "Events" } } } },
                  { fields: { Title: { value: "Plant tours" }, Link: { value: { href: "/connect-with-us/plant-tours", text: "Plant tours" } } } },
                ],
              },
            },
          ],
        },
      },
      {
        fields: {
          sectionName: { value: "Section 4" },
          sectionType: { fields: { Key: { value: "groupSectionType" }, Phrase: { value: "Group Section" } } },
          footerLinks: [
            {
              fields: {
                Title: {value: "TOOLS & RESOURCES"},
                Type: { fields: { Key: { value: "groupLinkType" }, Phrase: { value: "Group Link" } } },
                Link: { value: { href: "http://", text: "TOOLS & RESOURCES" } },
                List: [
                  { fields: { Title: { value: "Red right tractor"}, Link: { value: { href: "/tools-resources/right-red-tractor", text: "Red right tractor" } } } },
                  { fields: { Title: { value: "Compare specifications"}, Link: { value: { href: "/tools-resources/compare-specs", text: "Compare specifications" } } } },
                  { fields: { Title: { value: "Build &amp; price"}, Link: { value: { href: "/tools-resources/build-price", text: "Build & price" } } } },
                  { fields: { Title: { value: "Weighting &amp; ballasting"}, Link: { value: { href: "/tools-resources/weighting-ballasting", text: "Weighting & ballasting" } } } },
                  { fields: { Title: { value: "Brochures" }, Link: { value: { href: "/tools-resources/brochures", text: "Brochures" } } } },
                  { fields: { Title: { value: "FAQs" }, Link: { value: { href: "/connect-with-us/faqs", text: "FAQs" } } } },
                ],
              },
            },
          ],
        },
      },
      {
        fields: {
          sectionName: { value: "Section 5" },
          sectionType: { fields: { Key: { value: "groupSectionType" }, Phrase: { value: "Group Section" } } },
          footerLinks: [
            {
              fields: {
                Title: {value: "SUPPORT"},
                Type: { fields: { Key: { value: "groupLinkType" }, Phrase: { value: "Group Link" } } },
                Link: { value: { href: "#", text: "SUPPORT" } },
                List: [
                  { fields: { Title: { value: "AFS Troubleshooting &amp; support"}, Link: { value: { href: "/service-support/afs-troubleshooting-support", text: "AFS Troubleshooting & support" } } } },
                  { fields: { Title: { value: "Financing"}, Link: { value: { href: "/tools-resources/financing", text: "Financing" } } } },
                  { fields: { Title: { value: "Operator&rsquo;s manual"}, Link: { value: { href: "/service-support/operators-manuals", text: "Operator's manual" } } } },
                  { fields: { Title: { value: "Mobile apps"}, Link: { value: { href: "/tools-resources/apps", text: "Mobile Apps" } } } },
                ],
              },
            },
          ],
        },
      },
      {
        fields: {
          sectionName: { value: "Section 6" },
          sectionType: { fields: { Key: { value: "groupSectionType" }, Phrase: { value: "Group Section" } } },
          footerLinks: [
            {
              fields: {
                Title: {value: "COMPANY"},
                Type: { fields: { Key: { value: "groupLinkType" }, Phrase: { value: "Group Link" } } },
                Link: { value: { href: "", text: "COMPANY" } },
                List: [
                  { fields: { Title: { value: "About "}, Link: { value: { href: "", text: "About " } } } },
                  { fields: { Title: { value: "Careers"}, Link: { value: { href: "https://www.corporatendustrial.com/en-us/careers/overview/Pages/default.aspx", text: "Careers" } } } },
                  { fields: { Title: { value: "Newsroom"}, Link: { value: { href: "/company/newsroom", text: "Newsroom" } } } },
                  { fields: { Title: { value: "Investors"}, Link: { value: { href: "https://www.corporatendustrial.com/en-US/investor_relations/overview/Pages/default.aspx", text: "Investors" } } } },
                  { fields: { Title: { value: "Toys &amp; merchandise"}, Link: { value: { href: "", text: "Toys & merchandise" } } } },
                  { fields: { Title: { value: "Take action with "}, Link: { value: { href: "", text: "Take action with " } } } },

                ],
              },
            },
          ],
        },
      },
      {
        fields: {
          sectionName: { value: "Section 7" },
          sectionType: { fields: { Key: { value: "navigationSectionType" }, Phrase: { value: "Navigation Section" } } },
          footerLinks: [
            {
              fields: {
                Title: {value: "NAVIGATION"},
                Type: { fields: { Key: { value: "navigationLinkType" }, Phrase: { value: "Navigation Link" } } },
                Link: { value: { href: "#", text: "NAVIGATION" } },
                List: [
                  { fields: { Title: { value: "Site Map"}, Link: { value: { href: "/Pages/sitemap.aspx", text: "Site Map" } } } },
                  { fields: { Title: { value: "Terms &amp; Conditions"}, Link: { value: { href: "/Pages/legal-notice.aspx", text: "Terms & Conditions" } } } },
                  { fields: { Title: { value: "Legal Notice"}, Link: { value: { href: "/company/Legal Notice", text: "Legal Notice" } } } },
                  { fields: { Title: { value: "Privacy Policy"}, Link: { value: { href: "/Pages/privacy-policy.aspx", text: "Privacy Policy" } } } },
                  { fields: { Title: { value: "CCPA Privacy Policy"}, Link: { value: { href: "/Pages/privacy-notice-for-california-residents.aspx", text: "CCPA Privacy Policy" } } } },
                  { fields: { Title: { value: "Cookie Notice"}, Link: { value: { href: "", text: "Cookie Notice" } } } },
                ],
              },
            },
          ],
        },
      }
    ],
    copyrightText : { value: "© 2021 Corporate Industrial America LLC. All Rights Reserved.  and Corporate Industrial Capital are registered trademarks of Corporate Industrial America LLC." },
    image: {
      value: {
        src: "http://localhost:8085/images/Background-Footer-white_cut.jpg",
        alt: " Background",
        width: "1680",
        height: "460",
        title: " Footer Background white"
      }
    },
    backToTopText: { value: 'Back To Top' },
  },
};
